import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=734cf6fc&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('734cf6fc')) {
      api.createRecord('734cf6fc', component.options)
    } else {
      api.reload('734cf6fc', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=734cf6fc&", function () {
      api.rerender('734cf6fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KPVStl1Lffwx/JS/comp/ErrorMessage.vue"
export default component.exports